<template>
</template>
<script>
    import PreviewElement from "./PreviewElement";
    import HorizontalLineWrapperElement from "../../components/pagesbuilder/elements/HorizontalLineWrapperElement";

    export default {
        name: "PreviewHorizontalLineWrapperElement",
        mixins: [PreviewElement,HorizontalLineWrapperElement]
    }
</script>
